import { render, staticRenderFns } from "./wtAutoComplete.component.vue?vue&type=template&id=3b451cd8&"
import script from "./wtAutoComplete.component.vue?vue&type=script&lang=js&"
export * from "./wtAutoComplete.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports